import script from "./batch-payroll.vue?vue&type=script&lang=ts&setup=true"
export * from "./batch-payroll.vue?vue&type=script&lang=ts&setup=true"

import "./batch-payroll.vue?vue&type=style&index=0&id=b229e99e&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b229e99e"]])

export default __exports__